import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchClient } from "@/lib/api-client";

export const useFetchMyStatements = (limit = 10, enabled = true) =>
  useInfiniteQuery({
    queryKey: ["statement", "mine", limit],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await fetchClient.GET("/statements/mine", {
        params: {
          query: { page: typeof pageParam === "number" ? pageParam : 1, limit },
        },
      });
      const err = (response as { error?: unknown }).error;
      if (err) throw err;
      // response.data is typed `never` because the OpenAPI spec omits a response body;
      // cast through unknown to recover the runtime value.
      // biome-ignore lint/suspicious/noExplicitAny: untyped endpoint response
      return (response as unknown as { data?: unknown }).data as any;
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const pagination = lastPage?.data?.pagination as
        | { hasNextPage?: boolean; page?: number }
        | undefined;
      if (pagination?.hasNextPage) return (pagination.page ?? 1) + 1;
      return undefined;
    },
    enabled,
    refetchOnReconnect: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
